import 'gleam-shared/embeds/CaptureEmbed.scss'

import updateQuery from 'gleam-shared/network/updateQuery'
import injectScript from 'gleam-shared/browser/injectScript'
import whenCaptureShows from 'gleam-shared/domain/whenCaptureShows'
import { writeDom, cancelFastDom } from 'gleam-shared/browser/fastDom'

import DeadPreview from 'gleam-shared/embeds/DeadPreview'
import BasePreview from 'gleam-shared/embeds/BasePreview'

const MARKER = 'CaptureButton'
const EMBED_CLASS = 'capture-embed'
const TRIGGER_ATTR = 'data-capture-embed'

export default function CaptureEmbed(embed, key, script) {
  try {
    if (!key || !script) {
      throw new Error('The expected arguments are missing!')
    }

    return RealPreview(embed, key, script)
  } catch (err) {
    return DeadPreview('The capture embed', err)
  }
}

function RealPreview(embed, key, script) {
  const preview = BasePreview({
    destroy,
    description: `The ${key} capture`
  })

  writeDom(configure)

  promiseScript(key).then(promiseShow).then(
    preview.loadEmitter.emit,
    preview.errorEmitter.emit
  )

  return preview

  function destroy() {
    cancelFastDom(configure)
  }

  function configure() {
    embed.setAttribute(TRIGGER_ATTR, key)
    embed.classList.add(EMBED_CLASS)
  }

  function promiseScript() {
    const dangerousScript = updateQuery(script, { allow: key })
    return injectScript({ once: true, marker: MARKER, dangerousScript })
  }

  function promiseShow() {
    return whenCaptureShows(key)
  }
}
